module.exports = " <div class=\"login\">\n    <div class=\"header\">\n        <div><i class=\"icon logo\"></i></div>\n    </div>\n    <div class=\"lineVertical\">&nbsp;</div>\n    <div class=\"loginForm\">\n        <ui-view></ui-view>\n    </div>\n</div>\n<root-circle-loader></root-circle-loader>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/authentication.component.html
// module id = 1713
// module chunks = 0